import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { smallMediaQuery, mediumMediaQuery, largeMediaQuery } from '../../../common/utilities/sizeHelpers';
import { StoryThumbnail } from './storyThumbnail';
import { StoryReadMore } from './storyReadMore';
import { topStoriesNewsRoutes } from '../../../common/translation/translate';

export const StoryCardFlatItem = memo(({ nodeAlias, thumbnailImageLink, videoLink, storyTitle, enableSourceParameterOnStoriesLinks, source }) => {
    let newsDetailLink = `${topStoriesNewsRoutes.news}${nodeAlias}`;
    if (enableSourceParameterOnStoriesLinks) {
        newsDetailLink = `${location.origin}${newsDetailLink}?source=${source}`;
    }

    return (
        <StoryItemWrapper>
            {enableSourceParameterOnStoriesLinks 
                ? <Container href={newsDetailLink} target='_self'>
                    <SubStoryImageContainer>
                        <StoryThumbnail isSubStories={true} storyImageUrl={thumbnailImageLink} hasVideoLinkUrl={videoLink} />
                    </SubStoryImageContainer>
                    <SubStoriesSection>
                        <SubStoryDetails>
                            <SubStoryTitle>
                                {storyTitle}
                            </SubStoryTitle>
                        </SubStoryDetails>
                        <StoryReadMore translateKey='readMore' link={newsDetailLink} />
                    </SubStoriesSection>
                </Container>
                : <Container href={newsDetailLink}>
                    <SubStoryImageContainer>
                        <StoryThumbnail isSubStories={true} storyImageUrl={thumbnailImageLink} hasVideoLinkUrl={videoLink} />
                    </SubStoryImageContainer>
                    <SubStoriesSection>
                        <SubStoryDetails>
                            <SubStoryTitle>
                                {storyTitle}
                            </SubStoryTitle>
                        </SubStoryDetails>
                        <StoryReadMore translateKey='readMore' link={newsDetailLink} />
                    </SubStoriesSection>
                </Container>
            }
        </StoryItemWrapper>
    );
});

StoryCardFlatItem.displayName = 'StoryCardFlatItem';

StoryCardFlatItem.propTypes = {
    nodeAlias: PropTypes.string,
    thumbnailImageLink: PropTypes.string,
    videoLink: PropTypes.string,
    storyTitle: PropTypes.string
};

const StoryItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 20%;
    @media ${largeMediaQuery} {
        justify-content: flex-start;
        width: 95%;
    }
    @media ${mediumMediaQuery} {
        height: 112px;
    }
    @media ${smallMediaQuery} {
        height: 110px;
    }
`;

const Container = styled.a`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-decoration: none;
    width: 100%;
    height: 100%;
    cursor: pointer;
    @media ${largeMediaQuery} {
        height: 90%;
    }
`;

const SubStoryImageContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 40%;
    height: 90%;
    @media ${largeMediaQuery} {
        height: 100%;
    }
    @media ${smallMediaQuery} {
        width: 43%;
    }
`;

const SubStoriesSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 55%;
    height: 100%;
`;

const SubStoryDetails = styled.div`
    display: inline-block;
    overflow: hidden;
    height: 80%;
    width: 100%;
    @media ${smallMediaQuery} {
        width: 75%;
    }
`;

const SubStoryTitle = styled.div`
    display: block;
    display: -webkit-box;
    white-space: initial;
    font-size: 15px;
    color: #666;
    font-weight: 600;
    text-transform: capitalize;
    line-height: 1.5;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

